var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-container"},[_c('van-tabs',{attrs:{"color":"#3A8AE5"},on:{"click":_vm.onClick}},_vm._l((_vm.tabs),function(item,index){return _c('van-tab',{key:index,attrs:{"title":item.label,"name":item.name}},[_vm._t("default",null,{"tab":item,"index":index})],2)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }